import { Box, Text } from '@mantine/core';
import type { WaRendererProps } from './primitives';

/** Stickers render chrome-less — WhatsApp shows them on the thread background
 *  with no bubble, so a transparent WebP doesn't sit on a coloured slab. */
export function StickerMessage({ view }: WaRendererProps) {
  const url = view.media?.url;
  if (!url) {
    return (
      <Text size="sm" c="dimmed">
        {view.fallbackLabel}
      </Text>
    );
  }
  return (
    <Box style={{ lineHeight: 0 }}>
      <img
        src={url}
        alt={view.fallbackLabel}
        style={{ width: 128, height: 128, objectFit: 'contain' }}
      />
    </Box>
  );
}
